import * as runtime from '@/api/runtime'
import {
  BatchStatisticsGetSelectItemRequest,
  BatchStatisticsGetSelectItemRequestToJSON,
  BatchStatisticsGetSelectItemResult,
  BatchStatisticsGetSelectItemResultFromJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'
import {
  BatchStatisticsGetPredefinedSettingRequest,
  BatchStatisticsGetPredefinedSettingRequestToJSON
} from '@/api/models/batch/BatchStatisticsGetPredefinedSettingRequest'

import {
  BatchStatisticsLendSelectShelfRequest,
  BatchStatisticsLendSelectShelfRequestToJSON
} from '@/api/models/batch/BatchStatisticsLendSelectShelfRequest'
import {
  BatchStatisticsLendSelectShelfPageLoadResult,
  BatchStatisticsLendSelectShelfPageLoadResultFromJSON
} from '@/api/models/batch/BatchStatisticsLendSelectShelfPageLoadResult'

/**
 * 帳票作成
 */
export class BatchStatisticsLendSelectShelfApi extends runtime.BaseAPI {
  async createLendSelectShelf(
    request: BatchStatisticsLendSelectShelfRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/statistics/lend-select-shelf-type`,
      BatchStatisticsLendSelectShelfRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  /**
   * 検索状態登録
   * @param request
   */
  async registPattern(
    request: BatchStatisticsLendSelectShelfRequest
  ): Promise<BatchStatisticsGetSelectItemResult> {
    const response = await this.requestPost(
      `/batch/statistics/regist_lend_shelf_type_pattern`,
      BatchStatisticsLendSelectShelfRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsGetSelectItemResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchStatisticsLendSelectShelfPageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsLendSelectShelfPageLoadResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * セレクト項目取得
   * @param request
   */
  async getSelectItem(
    request: BatchStatisticsGetSelectItemRequest
  ): Promise<BatchStatisticsGetSelectItemResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_select_item`,
      BatchStatisticsGetSelectItemRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsGetSelectItemResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * 登録済み出力条件取得
   * @param request
   */
  async getPredefinedSetting(
    request: BatchStatisticsGetPredefinedSettingRequest
  ): Promise<BatchStatisticsLendSelectShelfPageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/list_item`,
      BatchStatisticsGetPredefinedSettingRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsLendSelectShelfPageLoadResultFromJSON(jsonValue)
    ).value()
  }
}
